import { render, staticRenderFns } from "./benefitsItem.vue?vue&type=template&id=650b71c4&scoped=true&"
import script from "./benefitsItem.vue?vue&type=script&lang=js&"
export * from "./benefitsItem.vue?vue&type=script&lang=js&"
import style0 from "./benefitsItem.vue?vue&type=style&index=0&id=650b71c4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "650b71c4",
  null
  
)

export default component.exports